// See corresponding test cases in
// tests/lib/utils/calculateStaffOnly.test.js

export const calculateStaffOnly = (isAdminUser, isStaffOnlyActivity, formValue) => {
  return isAdminUser ? formValue : isStaffOnlyActivity || formValue;
};
